<div
	kendoRippleContainer
	style="background-color: #f9fafb">
	<h1>KPA Theme Components</h1>

	<h2>NavBar</h2>
	<kendo-appbar>
		<kendo-appbar-section>
			<h1 class="kpa-navbar-title">Risk Management Center</h1>
		</kendo-appbar-section>
		<kendo-appbar-spacer></kendo-appbar-spacer>
		<kendo-appbar-section class="actions">
			<kendo-dropdownlist
				[size]="'small'"
				[rounded]="'medium'"
				[fillMode]="'outline'"
				[data]="languages"
				textField="text"
				valueField="value">
				<ng-template
					kendoDropDownListValueTemplate
					let-dataItem>
					<span class="template">{{ dataItem?.value }}</span
					>&nbsp;{{ dataItem?.text }}
				</ng-template>
			</kendo-dropdownlist>
			<kendo-appbar-spacer width="20px"></kendo-appbar-spacer>
			<kendo-dropdownbutton
				class="kpa-navbar-dropdownbutton"
				[data]="data"
				[size]="'small'"
				[rounded]="'none'"
				[fillMode]="'outline'">
				<kendo-avatar
					width="28px"
					height="28px"
					[imageSrc]="'https://demos.telerik.com/kendo-ui/content/web/Customers/GOURL.jpg'"
					[shape]="'circle'">
				</kendo-avatar>
				User Settings
			</kendo-dropdownbutton>
		</kendo-appbar-section>
	</kendo-appbar>

	<h2>Avatar</h2>
	<kendo-avatar
		initials="JS"
		size="large"></kendo-avatar>
	&nbsp;
	<kendo-avatar
		[size]="'large'"
		[rounded]="'full'"
		[imageSrc]="'https://demos.telerik.com/kendo-ui/content/web/Customers/GOURL.jpg'"
		[shape]="'circle'">
	</kendo-avatar>

	<h2>Button</h2>

	<h3>Primary Button</h3>
	<button
		kendoButton
		kpaKendoButton="primary">
		Default</button
	>&nbsp;
	<button
		kendoButton
		kpaKendoButton="primary"
		[disabled]="true">
		Disabled</button
	>&nbsp;
	<button
		kendoButton
		kpaKendoButton="primary">
		<kendo-svg-icon [icon]="folderIcon"></kendo-svg-icon> Button with Icon</button
	>&nbsp;

	<h3>Secondary Button</h3>

	<button
		kendoButton
		kpaKendoButton="secondary">
		Default</button
	>&nbsp;
	<button
		kendoButton
		kpaKendoButton="secondary"
		[disabled]="true">
		Disabled</button
	>&nbsp;
	<button
		kendoButton
		kpaKendoButton="secondary">
		<kendo-svg-icon [icon]="folderIcon"></kendo-svg-icon> Button with Icon</button
	>&nbsp;

	<h1>Dialog</h1>
	<div class="example-wrapper">
		<button
			kendoButton
			*ngIf="!dialogOpened && !windowOpened"
			(click)="open('dialog')">
			Open dialog</button
		>&nbsp;
		<button
			kendoButton
			*ngIf="!dialogOpened && !windowOpened"
			(click)="open('window')">
			Open window
		</button>
		<kendo-dialog
			title="Dialog Title"
			*ngIf="dialogOpened"
			(close)="close('dialog')"
			[minWidth]="250"
			[width]="350">
			<a href="www.kpa.io"> Are you sure you want to continue? </a>
			<kendo-dialog-actions>
				<button
					kendoButton
					kpaKendoButton="secondary"
					(click)="action('no')">
					No</button
				>&nbsp;
				<button
					kendoButton
					kpaKendoButton="primary"
					(click)="action('yes')">
					Yes
				</button>
			</kendo-dialog-actions>
		</kendo-dialog>

		<kendo-window
			[minWidth]="200"
			[minHeight]="125"
			title="About"
			*ngIf="windowOpened"
			(close)="close('window')">
			<p style="text-align: center">Additional info</p>
		</kendo-window>
	</div>

	<h2>Checkbox</h2>
	<input
		type="checkbox"
		#sampleCheckbox
		kendoCheckBox />
	<kendo-label
		class="k-checkbox-label"
		[for]="sampleCheckbox"
		text="I accept the terms and conditions"></kendo-label>
	<h1>Form</h1>
	<div class="example-wrap">
		<form
			class="k-form k-form-md"
			[formGroup]="registerForm">
			<fieldset class="k-form-fieldset">
				<legend class="k-form-legend">User Details</legend>
				<kendo-formfield>
					<kendo-label
						labelCssClass="k-form-label"
						[for]="firstName"
						text="First Name"></kendo-label>
					<input
						kendoTextBox
						kpaKendoTextbox="flat"
						formControlName="firstName"
						#firstName
						required />

					<kendo-formhint>Your first name</kendo-formhint>
					<kendo-formerror>Error: First name is required</kendo-formerror>
				</kendo-formfield>

				<kendo-formfield>
					<kendo-label
						labelCssClass="k-form-label"
						[for]="lastName"
						text="Last Name"></kendo-label>
					<kendo-textbox
						formControlName="lastName"
						[clearButton]="true"
						#lastName
						required></kendo-textbox>

					<kendo-formhint>Your last name</kendo-formhint>
					<kendo-formerror>Error: Last name is required</kendo-formerror>
				</kendo-formfield>

				<kendo-formfield>
					<kendo-label
						labelCssClass="k-form-label"
						[for]="birthDate"
						[optional]="true"
						text="Birth Date"></kendo-label>
					<kendo-datepicker
						#birthDate
						formControlName="birthDate"
						[min]="min"
						[max]="max">
					</kendo-datepicker>

					<kendo-formhint>Your birth date</kendo-formhint>
				</kendo-formfield>

				<kendo-formfield>
					<kendo-label
						labelCssClass="k-form-label"
						[for]="email"
						text="Email"></kendo-label>
					<kendo-textbox
						[fillMode]="'outline'"
						formControlName="email"
						#email
						[clearButton]="true"
						required></kendo-textbox>
					<kendo-formerror>Error: Not valid email format</kendo-formerror>
				</kendo-formfield>
				<kendo-formfield>
					<kendo-label
						labelCssClass="k-form-label"
						[for]="vehicle"
						text="Select vehicle"></kendo-label>
					<kendo-dropdownlist
						#vehicle
						formControlName="vehicle"
						[data]="vehicles"
						[defaultItem]="{ text: 'Select vehicle', value: null }"
						textField="text"
						valueField="value"
						[valuePrimitive]="true"
						required>
					</kendo-dropdownlist>
					<kendo-formerror>Required</kendo-formerror>
				</kendo-formfield>
				<kendo-formfield>
					<div class="k-checkbox-wrap">
						<input
							#acceptNews
							type="checkbox"
							kendoCheckBox
							formControlName="acceptNews" />
						<kendo-label
							[for]="acceptNews"
							class="k-checkbox-label"
							text="I want to receive notifications"></kendo-label>
					</div>

					<kendo-formhint>You will receive our latest updates and promotions on your email</kendo-formhint>
				</kendo-formfield>

				<div class="k-form-buttons">
					<button
						kendoButton
						kpaKendoButton="primary"
						(click)="submitForm()">
						Submit
					</button>
					<button
						kendoButton
						kpaKendoButton="secondary"
						(click)="clearForm()">
						Clear
					</button>
				</div>
			</fieldset>
		</form>
	</div>
	<h2>Stack Layout</h2>

	<kendo-stacklayout
		[gap]="15"
		[orientation]="'vertical'">
		<kendo-card width="auto">
			<kendo-card-body>
				<div style="display: flex; justify-content: space-between">
					<div style="flex: 1">
						<h3>Back Safety</h3>
					</div>
					<div style="flex: 1">
						<h3>Type: Video</h3>
					</div>
					<div style="flex: 1">
						<h3>Date</h3>
					</div>
				</div>
			</kendo-card-body>
		</kendo-card>
		<kendo-card width="auto">
			<kendo-card-body>
				<div style="display: flex; justify-content: space-between">
					<div style="flex: 1">
						<h3>Back Safety</h3>
					</div>
					<div style="flex: 1">
						<h3>Type: Video</h3>
					</div>
					<div style="flex: 1">
						<h3>Date</h3>
					</div>
				</div>
			</kendo-card-body>
		</kendo-card>
		<kendo-card width="auto">
			<kendo-card-body>
				<div style="display: flex; justify-content: space-between">
					<div style="flex: 1">
						<h3>Back Safety</h3>
					</div>
					<div style="flex: 1">
						<h3>Type: Video</h3>
					</div>
					<div style="flex: 1">
						<h3>Date</h3>
					</div>
				</div>
			</kendo-card-body>
		</kendo-card>
	</kendo-stacklayout>

	<h2>Grid</h2>
	<kendo-grid
		kpaGrid
		[data]="gridData"
		[pageSize]="gridSettings.state.take"
		[skip]="gridSettings.state.skip"
		[sort]="gridSettings.state.sort"
		[filter]="gridSettings.state.filter"
		[sort]="gridSettings.state.sort"
		(dataStateChange)="dataStateChange($event)"
		[pageable]="true"
		(columnReorder)="onReorder($event)"
		(columnResize)="onResize($event)"
		(columnVisibilityChange)="onVisibilityChange($event)"
		(filterChange)="filterChange($event)"
		style="width: 100%"
		[filterable]="true"
		[sortable]="true"
		[reorderable]="true"
		[resizable]="true"
		[columnMenu]="{ filter: false, sort: false }"
		class="card card-grid kpa-grid">
		<kendo-grid-column
			*ngFor="let col of gridSettings.columnsConfig"
			[field]="col.field"
			[title]="col.title"
			[width]="col.width"
			[filter]="col.filter"
			[filterable]="col.filterable"
			[hidden]="col.hidden"
			[format]="col.format"
			[locked]="col.locked"
			class="col.class"
			[sortable]="col.sortable"
			[minResizableWidth]="col.minResizableWidth">
			<ng-template
				kendoGridFilterCellTemplate
				let-filter
				let-column="column">
				<div
					id="grid_IncidentSearch_ProductID"
					class="incidentTypeFilter"
					*ngIf="col.field === 'ProductID'">
					<kendo-grid-string-filter-cell
						[column]="column"
						[filter]="filter"
						filterDelay="0"
						operator="contains">
					</kendo-grid-string-filter-cell>
				</div>

				<div
					id="grid_IncidentSearch_ProductName"
					*ngIf="col.field === 'ProductName'">
					<kendo-grid-string-filter-cell
						[column]="column"
						[filter]="filter"
						filterDelay="0"
						operator="contains">
					</kendo-grid-string-filter-cell>
				</div>
				<div
					id="grid_IncidentSearch_FirstOrderedOn"
					*ngIf="col.field === 'FirstOrderedOn'">
					<kendo-grid-date-filter-cell
						[showOperators]="false"
						[column]="column"
						[filter]="filter"
						[formatPlaceholder]="{
							year: 'yyyy',
							month: 'MM',
							day: 'dd',
						}">
					</kendo-grid-date-filter-cell>
				</div>
				<div
					id="grid_IncidentSearch_UnitPriceFilter"
					*ngIf="col.field === 'UnitPrice'">
					<kendo-grid-string-filter-cell
						[column]="column"
						[filter]="filter"
						filterDelay="0"
						operator="contains">
					</kendo-grid-string-filter-cell>
				</div>

				<div
					id="grid_IncidentSearch_DiscontinuedFilter"
					*ngIf="col.field === 'Discontinued'">
					<kendo-grid-string-filter-cell
						[column]="column"
						[filter]="filter"
						filterDelay="0"
						operator="contains">
					</kendo-grid-string-filter-cell>
				</div>
				<div
					id="grid_IncidentSearch_LastOrderedOn"
					*ngIf="col.field === 'LastOrderedOn'">
					<kendo-grid-date-filter-cell
						[showOperators]="false"
						[column]="column"
						[filter]="filter"
						[formatPlaceholder]="{
							year: 'yyyy',
							month: 'MM',
							day: 'dd',
						}">
					</kendo-grid-date-filter-cell>
				</div>
				<div
					id="grid_IncidentSearch_AssignedTo"
					*ngIf="col.field === 'AssignedTo'">
					<kendo-grid-string-filter-cell
						[column]="column"
						[filter]="filter"
						filterDelay="0"
						operator="startswith">
					</kendo-grid-string-filter-cell>
				</div>
			</ng-template>

			<ng-template
				kendoGridCellTemplate
				let-dataItem
				let-rowIndex="rowIndex"
				let-columnIndex="columnIndex">
				<div *ngIf="col.field === 'ProductID'">
					<span id="grid_IncidentSearch_column_ProductID_r{{ rowIndex }}c{{ columnIndex }}">
						{{ dataItem.ProductID }}
					</span>
				</div>
				<div *ngIf="col.field === 'ProductName'">
					<span id="grid_IncidentSearch_column_ProductName_r{{ rowIndex }}c{{ columnIndex }}">
						{{ dataItem.ProductName }}
					</span>
				</div>
				<div *ngIf="col.field === 'FirstOrderedOn'">
					<span id="grid_IncidentSearch_column_FirstOrderedOn_r{{ rowIndex }}c{{ columnIndex }}">
						{{ dataItem.FirstOrderedOn }}
					</span>
				</div>

				<div *ngIf="col.field === 'UnitPrice'">
					<span id="grid_IncidentSearch_column_UnitPrice_r{{ rowIndex }}c{{ columnIndex }}">
						{{ dataItem.UnitPrice }}
					</span>
				</div>

				<div *ngIf="col.field === 'Discontinued'">
					<span id="grid_IncidentSearch_column_Discontinued_r{{ rowIndex }}c{{ columnIndex }}">
						{{ dataItem.Discontinued }}
					</span>
				</div>
				<div *ngIf="col.field === 'LastOrderedOn'">
					<span id="grid_IncidentSearch_column_LastOrderedOn_r{{ rowIndex }}c{{ columnIndex }}"> {{ dataItem.LastOrderedOn }} </span>
				</div>
				<div *ngIf="col.field === 'AssignedTo'">
					<span id="grid_IncidentSearch_column_AssignedTo_r{{ rowIndex }}c{{ columnIndex }}"> {{ dataItem.AssignedTo }} </span>
				</div>
			</ng-template>
		</kendo-grid-column>

		<ng-template kendoGridNoRecordsTemplate> {{ noDataFoundGridText }} </ng-template>
	</kendo-grid>
	<h2>Tab Strip</h2>
	<kendo-tabstrip>
		<kendo-tabstrip-tab
			[title]="'Paris'"
			[selected]="true">
			<ng-template kendoTabContent>
				<p>
					Paris is the capital and most populous city of France. It has an area of 105 square kilometres (41 square miles) and a population
					in 2013 of 2,229,621 within its administrative limits. The city is both a commune and department, and forms the centre and
					headquarters of the Île-de-France, or Paris Region, which has an area of 12,012 square kilometres (4,638 square miles) and a
					population in 2014 of 12,005,077, comprising 18.2 percent of the population of France.
				</p>
			</ng-template>
		</kendo-tabstrip-tab>
		<kendo-tabstrip-tab [title]="'New York City'">
			<ng-template kendoTabContent>
				<p>
					The City of New York, often called New York City or simply New York, is the most populous city in the United States. With an
					estimated 2015 population of 8,550,405 distributed over a land area of just 305 square miles (790 km2), New York City is also the
					most densely populated major city in the United States. Located at the southern tip of the state of New York, the city is the
					center of the New York metropolitan area, one of the most populous urban agglomerations in the world.
				</p>
				<p>
					A global power city, New York City exerts a significant impact upon commerce, finance, media, art, fashion, research, technology,
					education, and entertainment, its fast pace defining the term New York minute. Home to the headquarters of the United Nations, New
					York is an important center for international diplomacy and has been described as the cultural and financial capital of the world.
				</p>
			</ng-template>
		</kendo-tabstrip-tab>
		<kendo-tabstrip-tab [title]="'Tallinn'">
			<ng-template kendoTabContent>
				<p>
					Tallinn is the capital and largest city of Estonia. It is situated on the northern coast of the country, on the shore of the Gulf
					of Finland, 80 km (50 mi) south of Helsinki, east of Stockholm and west of Saint Petersburg. From the 13th century until 1918 (and
					briefly during the Nazi occupation of Estonia from 1941 to 1944), the city was known as Reval. Tallinn occupies an area of 159.2
					km2 (61.5 sq mi) and has a population of 443,894. Approximately 32% of Estonia's total population lives in Tallinn.
				</p>
				<p>
					Tallinn was founded in 1248, but the earliest human settlements are over 5,000 years old, making it one of the oldest capital
					cities of Northern Europe. Due to its strategic location, the city became a major trade hub, especially from the 14th to the 16th
					century, when it grew in importance as part of the Hanseatic League.
				</p>
			</ng-template>
		</kendo-tabstrip-tab>
		<kendo-tabstrip-tab
			[title]="'Sydney'"
			[disabled]="true"></kendo-tabstrip-tab>
	</kendo-tabstrip>
	<h1>Loader</h1>
	<kpa-loader></kpa-loader>
</div>
